import React, { Component } from 'react';
import { bool, func, number, object, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { actions as jobPricingStatusActions } from '../../reducers/modules/jobs/jobPricingStatus/jobPricingStatus';
import { actions as jobMatchingActions } from '../../reducers/modules/jobs/jobMatching/jobMatching';
import { actions as organizationStatisticsActions } from '../../reducers/modules/organization/organizationStatistics/organizationStatistics';
import { actions as surveyActivityActions } from '../../reducers/modules/surveys/surveyActivity/surveyActivity';
import MarketPricingDisplay from '../../components/Home/MarketPricing/MarketPricing';
import { NEW_MARKET_PRICING_URL } from '../../containers/Home/Home';

class MarketPricing extends Component {
  static propTypes = {
    dispatch: func,
    history: object,
    jobPricingStatus: shape({
      data: shape({
        neither: number,
        priced: number,
        slotted: number
      }),
      error: string,
      loading: bool
    }),
    location: object,
    match: object,
    priceJobClick: func,
    adHocPricingClick: func,
    pricingYear: number,
    launchDarklyFeatureFlags: object,
    permissions: object,
    subsite: string
  };

  constructor(props) {
    super(props);
    this.chartInteraction = this.chartInteraction.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    jobPricingStatusActions.getJobPricingStatus(dispatch);
    organizationStatisticsActions.getOrganizationStatistics(dispatch);
    surveyActivityActions.getSurveyActivity(dispatch);
    jobMatchingActions.getJobMatches(dispatch);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { dispatch, surveyYear } = this.props;
    if (this.props === nextProps) return;
    if (surveyYear !== nextProps.surveyYear) jobPricingStatusActions.getJobPricingStatus(dispatch);
  }

  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps;
  }

  chartInteraction(pricingName) {
    const { subsite } = this.props;
    const baseUrl = `/view/o/${subsite}/mp`;
    document.location.href = `${baseUrl}${NEW_MARKET_PRICING_URL}?job_price_status%5B0%5D=${pricingName}`;
  }

  render() {
    const {
      jobPricingStatus,
      priceJobClick,
      adHocPricingClick,
      surveyYear,
      launchDarklyFeatureFlags,
      permissions
    } = this.props;
    const { data, error, loading } = jobPricingStatus;

    return (
      <MarketPricingDisplay
        chartInteraction={this.chartInteraction}
        error={error}
        loading={loading}
        neither={data.neither}
        priced={data.priced}
        priceJobClick={priceJobClick}
        adHocPricingClick={adHocPricingClick}
        pricingYear={surveyYear}
        slotted={data.slotted}
        launchDarklyFeatureFlags={launchDarklyFeatureFlags}
        permissions={permissions}
      />
    );
  }
}

const mapStateToProps = ({ jobPricingStatus, organizationStatistics, session }) => ({
  jobPricingStatus,
  surveyYear: organizationStatistics.data.statistics.surveyYear,
  permissions: session.user.rights,
  subsite: session.organization.code
});

export default connect(mapStateToProps)(withRouter(MarketPricing));
